module.exports = __webpack_public_path__ + "img/cleared.6a230789.png";